import * as React from "react";
import {
    PlasmicDrivePlugin,
    DefaultDrivePluginProps
} from "./plasmic/main/PlasmicDrivePlugin";
import useDrivePicker from "react-google-drive-picker";
import {useCallback, useEffect} from "react";
import DocumentEntry from "./DocumentEntry";
import useGoogleIDStore from "./store";

export interface DrivePluginProps extends DefaultDrivePluginProps {
    driveLinks: any[],
    onChange: (noteChanges: any) => any,
    showGoogleDriveSheet: any
}

function DrivePlugin({driveLinks, onChange, showGoogleDriveSheet, ...rest}: DrivePluginProps) {
    const [openPicker, authResponse] = useDrivePicker();
    const token: any = useGoogleIDStore((state: any) => state.token);
    const setToken: any = useGoogleIDStore((state: any) => state.setToken);
    useEffect(() => authResponse?.access_token && setToken(authResponse.access_token),
        [authResponse, setToken]);

    const handleOpenPicker = useCallback(() => {
        openPicker({
            clientId: "586143929623-u7hru1mactd42b2n8lvh8ut99uslngs7.apps.googleusercontent.com",
            developerKey: "AIzaSyCyEF9D7wYsvH0on3jZTXHPjZRh-ljWscQ",
            viewId: "DOCS",
            token: token,
            showUploadView: true,
            showUploadFolders: true,
            setSelectFolderEnabled: true,
            supportDrives: true,
            multiselect: true,
            // customViews: customViewsArray, // custom view
            callbackFunction: (data) => {
                if (data.action === 'cancel') {
                    console.log('User clicked cancel/close button')
                } else if (data.action === "picked") {
                    onChange({googleDocs: [...driveLinks, ...data.docs]});
                }
            }
        })
    }, [openPicker, token, onChange, driveLinks]);

    const removeFile = useCallback((document: any) => {
        onChange({googleDocs: driveLinks.filter((d) => d.id !== document.id)});
    }, [onChange, driveLinks]);

    return <PlasmicDrivePlugin
        linkButton={{
            onClick: () => handleOpenPicker()
        }}
        links={{
            children: driveLinks.map((d) => <DocumentEntry key={d.id} document={d} removeFile={removeFile}
                                                           showGoogleDriveSheet={showGoogleDriveSheet}/>)
        }}
        {...rest}
    />;
}

export default DrivePlugin;
